import React from 'react';

import { Button, Card, CardContent, CardHeader, Divider, Stack, Typography } from '@mui/material';

import { useBorr } from '../../hooks/useBorr';

type Props = {
  strategyId: string;
  updatedAt: string;
  success?: boolean;
  errorDescription?: string;
};

export const PublishBorrSection: React.FC<Props> = ({ strategyId, updatedAt, success, errorDescription }) => {
  const { loading, onPublishToBorr } = useBorr(strategyId);
  return (
    <Card>
      <CardHeader title="Публикация в БОРР/КХД" />
      <Divider />
      <CardContent>
        <Stack spacing={1}>
          <Button variant="contained" disabled={loading} onClick={onPublishToBorr} aria-label="Опубликовать">
            Опубликовать
          </Button>
          <Typography variant="body2">
            Подтверждение получено: <i>{updatedAt}.</i> {success === true ? 'Успешно' : ''}
            {success === false && (
              <Typography component="span" color="error">
                Ошибка: {errorDescription}
              </Typography>
            )}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};
